// @flow
import React from "react";
import type { FlagContentProps } from "../types";

const Sweden = ({ circular }: FlagContentProps) =>
  circular ? (
    <React.Fragment>
      <g clipPath="url(#clip0_3_19)">
        <path d="M26 0H-6V20H26V0Z" fill="#2F67BD" />
        <path d="M26 7.83553H-6V12.1645H26V7.83553Z" fill="#FFD470" />
        <path d="M7.41412 0H2.72723V20H7.41412V0Z" fill="#FFD470" />
      </g>
      <defs>
        <clipPath id="clip0_3_19">
          <rect width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <g clipPath="url(#clip0_2_1647)">
        <path d="M32 0H0V20H32V0Z" fill="#2F67BD" />
        <path d="M32 7.83553H0V12.1645H32V7.83553Z" fill="#FFD470" />
        <path d="M13.4141 0H8.72723V20H13.4141V0Z" fill="#FFD470" />
      </g>
      <defs>
        <clipPath id="clip0_2_1647">
          <rect width="32" height="20" rx="2" fill="white" />
        </clipPath>
      </defs>
    </React.Fragment>
  );

// $FlowFixMe
export default React.memo(Sweden);
